import { render, staticRenderFns } from "./MFAManagement.vue?vue&type=template&id=487a0424"
import script from "./MFAManagement.vue?vue&type=script&lang=ts"
export * from "./MFAManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports